/**
 * Model reprezentujący treść i metadane spersonalizowanego dokumentu GDPR (Polityki Prywatności)
 * utworzonego przez konkretnego klienta w Dashboardzie.
 */
export class GdprTerms {

  /**
   * Unikalny identyfikator dokumentu (UUID).
   * To właśnie ten klucz jest przypisywany do profilu klienta (`Client.individualGDPRTermsUUID`),
   */
  public uuid: string;

  /**
   * Data i czas utworzenia wersji dokumentu.
   * Kluczowe dla celów audytowych (wersjonowanie zgód prawnych).
   */
  public created: Date;

  /**
   * Skompilowana treść dokumentu (gotowy kod HTML).
   */
  public value: string;

  /**
   * Identyfikator pracownika/administratora (z modelu `User`), który zredagował
   * i opublikował ten dokument w Dashboardzie.
   */
  public createdByUUID: string;

  /**
   * ID Klienta Biznesowego, do którego należy ten dokument.
   */
  public vClientUUID: string;

  /**
   * Vetcode konkretnej placówki, jeśli dokument RODO dotyczy tylko jednego gabinetu,
   * a nie całej sieci klienta.
   */
  public vetcodeId: number;

  /**
   * Zserializowany obiekt `GdrpAcceptanceData` w formacie JSON.
   * Pełni funkcję "cyfrowego odcisku palca" (Snapshot). Zapisuje dokładne dane firmy
   * (nazwę, NIP, adres) oraz dokładny czas z momentu wyrażenia zgody.
   */
  public jsonValue: string;

  /**
   * Identyfikator szablonu systemowego.
   * Ułatwia klinikom start – zamiast pisać GDPR od zera, mogą wczytać szablon.
   */
  public template: string;

  /**
   * Nazwa pliku GdprTerms.
   */
  public fileName: string;
}
